"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var DataGridHeaderColumn = function (props) {
    var label = props.column.label;
    return (react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center" },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement("span", null, label)),
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Icon, null, "help"))));
};
exports.default = DataGridHeaderColumn;
